<template>
<v-container fluid grid-list-lg>
  <v-layout row wrap>
    <v-flex>
      <v-card>
        <v-card-title primary-title class="primary white--text headline">
          Scheduled Job Form
        </v-card-title>
        <v-card-text>
          <form>
            <v-layout row>
              <v-flex xs6>
                <v-text-field
                disabled
                v-model="item.id"
                label="ID">
                </v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-select
                dense
                label="Type"
                item-text="name"
                item-value="id"
                :items="jobTypeCollection"
                v-validate="'required'"
                data-vv-name="type"
                :error-messages="errors.collect('type')"
                v-model="item.type">
                </v-select>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs6>
                <v-select
                dense
                label="Dataset"
                clearable
                v-validate="datasetValidationRules"
                :error-messages="errors.collect('dataset')"
                data-vv-name="dataset"
                :items="datasetCollection"
                v-model="item.datasetId"
                :disabled="item.type != 0 && item.type != 8 && item.type != 14 && item.type != 15 && item.type != 16">
                </v-select>
              </v-flex>
              <v-flex xs6>
                <v-select
                dense
                label="Topic Model"
                clearable
                v-validate="topicModelValidationRules"
                :error-messages="errors.collect('topic model')"
                data-vv-name="topic model"
                :items="topicModelCollection"
                v-model="item.topicModelId"
                :disabled="item.type != 2 && item.type != 3 && item.type != 6 && item.type != 7 && item.type != 8 && item.type != 9 && item.type != 15 && item.type != 16">
                </v-select>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs6>
                <v-select
                dense
                label="Solr Core Name"
                chips
                deletable-chips
                v-validate="solrCoreNamesValidationRules"
                :error-messages="errors.collect('solr core names')"
                data-vv-name="solr core names"
                :items="solrCoreNameCollection"
                v-model="item.solrCoreNames"
                multiple
                :disabled="item.type != 1 && item.type != 2 && item.type != 0">
                </v-select>
              </v-flex>
              <v-flex xs6>
                <v-select
                dense
                label="Annotation Work"
                clearable
                v-validate="annotationWorkValidationRules"
                :error-messages="errors.collect('annotation work')"
                data-vv-name="annotation work"
                :items="annotationWorkCollection"
                v-model="item.annotationWorkId"
                :disabled="item.type != 3 && item.type != 6 && item.type != 7 && item.type != 8 && item.type != 9">
                </v-select>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex class="text-xs-center">
                <v-text-field
                label="Cron Expression"
                v-validate="cronValidationRules"
                :error-messages="errors.collect('cron expression')"
                data-vv-name="cron expression"
                v-model="item.cronText"
                :disabled="!item.isRecurrent"
                hint="minute - hour - day - month - day_of_week"
                >
                </v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-select
                dense
                label="Sentiment Model"
                :error-messages="errors.collect('sentiment model')"
                data-vv-name="sentiment model"
                :items="sentimentModelCollection"
                v-model="item.sentimentModelId"
                v-validate="sentimentModelValidationRules"
                :disabled="item.type != 4 && item.type != 1 && item.type != 16">
                </v-select>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs3 class="text-xs-center">
                <v-switch
                  :label="item.isRecurrent ? 'Recurrent' : 'Once'"
                  v-model="item.isRecurrent"
                ></v-switch>
              </v-flex>
              <v-flex xs3 class="text-xs-center">
                <v-switch
                  :label="item.isFromScratch ? 'Start from scratch' : 'Continue from last job'"
                  v-model="item.isFromScratch"
                  hint="ALL previous jobs will be ignored"
                  :persistent-hint="item.isFromScratch"
                ></v-switch>
              </v-flex>
              <v-flex xs3 class="text-xs-center" v-if="item.type==2">
                <v-checkbox
                  v-model="item.isEmotionModel"
                  label="SetEmotionModel"
                  color="primary"
                >
                </v-checkbox>
              </v-flex>
            </v-layout>
          </form>
        </v-card-text>
        <v-card-actions style="background: hsl(0, 0%, 97%)" class="pa-3">
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" flat depressed @click.native="cancel" :disabled="saveLoading">Cancel</v-btn>
          <v-btn color="accent" class="white--text" depressed @click.native="validateBeforeSubmit(save)" :loading="saveLoading" :disabled="saveLoading">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>
  </v-layout>
</v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'scheduled-job-item',
  props: {
    id: {
      type: String,
      required: false,
      default: ''
    }
  },
  created () {
    if (!this.isNew) {
      this.setLoader({
        loading: true
      })
      this.fetchScheduledJobItem()
    }
    this.axios.get('/topic-models')
      .then(response => {
        if (response.data) {
          this.topicModelCollection = response.data.map(t => ({
            value: t.id,
            text: t.name
          }))
        }
      })
      .catch(error => {
        this.handleAxiosError(error)
      })

    this.axios.get('/datasets')
      .then(response => {
        if (response.data) {
          this.datasetCollection = response.data.map(t => ({
            value: t.id,
            text: t.name
          }))
        }
      })
      .catch(error => {
        this.handleAxiosError(error)
      })

    this.axios.get('/sentiment-models')
      .then(response => {
        if (response.data) {
          var custom = response.data.custom_models.map(t => ({
            value: t.id,
            text: t.name
          }))
          custom = custom.filter(e => e.value !== 1 && e.value !== 2)
          this.sentimentModelCollection = custom
        }
      })
      .catch(error => {
        this.handleAxiosError(error)
      })
  },
  data () {
    return {
      item: {
        id: '',
        topicModelId: undefined,
        annotationWorkId: undefined,
        datasetId: undefined,
        sentimentModelId: undefined,
        status: undefined,
        type: undefined,
        solrCoreNames: [],
        isFromScratch: false,
        isRecurrent: false,
        cronText: '0 * * * *',
        cronMinute: '0',
        cronHour: '*',
        cronDay: '*',
        cronMonth: '*',
        cronDayOfWeek: '*',
        isEmotionModel: false
      },
      saveLoading: false,
      datasetCollection: [],
      topicModelCollection: [],
      annotationWorkCollection: [],
      sentimentModelCollection: []
    }
  },
  computed: {
    isNew () {
      return this.id == null || this.id === ''
    },
    ...mapState({
      solrCoreNameCollection: state => state.configurations.solrCoreNames,
      jobTypeCollection: state => state.configurations.jobTypes,
      jobStatusCollection: state => state.configurations.jobStatus
    }),
    datasetValidationRules () {
      if (this.item.type === 0 || this.item.type === 14 || this.item.type === 15 || this.item.type === 16) {
        return 'required'
      }

      return ''
    },
    topicModelValidationRules () {
      if (this.item.type === 2 || this.item.type === 3 || this.item.type === 8 || this.item.type === 15) {
        return 'required'
      }

      return ''
    },
    solrCoreNamesValidationRules () {
      if (this.item.type === 0 || this.item.type === 1 || this.item.type === 2) {
        return 'required'
      }

      return ''
    },
    annotationWorkValidationRules () {
      if (this.item.type === 3 || this.item.type === 6 || this.item.type === 7 || this.item.type === 8 || this.item.type === 9) {
        return 'required'
      }
    },
    sentimentModelValidationRules () {
      if (this.item.type === 1 || this.item.type === 4) {
        return 'required'
      }
    },
    cronValidationRules () {
      if (this.item.isRecurrent) {
        return 'required'
      }

      return ''
    }
  },
  methods: {
    cancel () {
      this.$router.go(-1)
    },
    fetchScheduledJobItem () {
      this.axios.get(`/jobs/${this.id}`)
        .then(response => {
          this.setScheduledJobItem(response.data)
        })
        .catch(error => {
          this.handleAxiosError(error)
        })
        .finally(() => {
          this.setLoader({
            loading: false
          })
        })
    },
    setScheduledJobItem (item) {
      this.item = this.mapScheduledJobItem(item)
    },
    mapScheduledJobItem (item) {
      return {
        id: item.id,
        topicModelId: item.topic_model ? item.topic_model.id : undefined,
        datasetId: item.dataset ? item.dataset.id : undefined,
        sentimentModelId: item.sentiment_model ? item.sentiment_model.id : undefined,
        annotationWorkId: item.annotation_work ? item.annotation_work.id : undefined,
        type: item.job_type,
        solrCoreNames: item.target_solr_core_names,
        isFromScratch: item.from_scratch,
        isRecurrent: item.recurrent,
        cronMinute: item.cron_minute,
        cronHour: item.cron_hour,
        cronDay: item.cron_day,
        cronMonth: item.cron_month,
        cronDayOfWeek: item.cron_day_of_week,
        cronText: [item.cron_minute, item.cron_hour, item.cron_day, item.cron_month, item.cron_day_of_week].join(' '),
        isEmotionModel: item.isEmotionModel
      }
    },
    save () {
      this.saveLoading = true
      var splittedCron = this.item.cronText.split(' ')
      let itemToSave = {
        topic_model: this.item.topicModelId || null,
        annotation_work: this.item.annotationWorkId || null,
        sentiment_model: this.item.sentimentModelId || null,
        dataset: this.item.datasetId || null,
        job_type: this.item.type,
        target_solr_core_names: this.item.solrCoreNames || [],
        from_scratch: this.item.isFromScratch,
        recurrent: this.item.isRecurrent,
        cron_minute: splittedCron[0],
        cron_hour: splittedCron[1],
        cron_day: splittedCron[2],
        cron_month: splittedCron[3],
        cron_day_of_week: splittedCron[4],
        isEmotionModel: this.item.isEmotionModel
      }

      if (this.isNew) {
        this.axios.post('/jobs', itemToSave)
          .then(response => {
            this.$router.go(-1)
          })
          .catch(error => {
            this.handleAxiosError(error)
          })
          .finally(() => {
            this.saveLoading = false
          })
      } else {
        this.axios.put(`/jobs/${this.item.id}`, itemToSave)
          .then(response => {
            this.$router.go(-1)
          })
          .catch(error => {
            this.handleAxiosError(error)
          })
          .finally(() => {
            this.saveLoading = false
          })
      }
    },
    fetchAnnotationWorks () {
      if (this.item.type === 9 && !this.item.topicModelId) {
        this.axios.get('/annotation-works', {
          params: {
            sentiment: true
          }
        }).then(response => {
          this.annotationWorkCollection = response.data.map((aw) => { return {text: aw.name, value: aw.id} })
        })
      } else {
        this.axios.get('/annotation-works', {
          params: {
            topic_model_id: this.item.topicModelId
          }
        }).then(response => {
          this.annotationWorkCollection = response.data.map((aw) => { return {text: aw.name, value: aw.id} })
        })
      }
    },
    ...mapActions({
      setLoader: 'loader/setLoader'
    })
  },
  watch: {
    item: {
      deep: true,
      handler (newValue) {
        if (newValue.topicModelId || newValue.type === 9) {
          this.fetchAnnotationWorks()
        }
      }
    }
  }
}
</script>

<style>

</style>
